import { User } from "@design-system/User/User";

type Props = {
  name: string;
  email?: string;
};

export const UserCell = ({ name, email }: Props) => {
  return <User name={name} email={email} />;
};
